import type {
  ButtonIconSize,
  ButtonIconVariant,
} from '~/components/Button/ButtonIcon/types';

export const PROPS = {
  size: '40-20' as ButtonIconSize,
  variant: 'ghost-grey' as ButtonIconVariant,
  key: 'help',
  id: 'help-launcher',
  className: 'z-50',
  iconProps: { stroke: undefined },
  icon: 'help',
};
